import {Splide} from "@splidejs/splide";

const sliderGallery = document.getElementById("gallerySlider");
if (sliderGallery) {
    new Splide(sliderGallery, {
        type   : 'loop',
        arrows: false,
        perPage: 4,
        pagination: false,     
        autoplay: true,
        interval: 2500, 
        speed: 2000,
        focus    : 'center',
        autoWidth: true, 
        gap    : '1rem', 
        breakpoints: {
            1024: {
                perPage: 2,  // Display 2 slides on tablets
            },
            767: {
                perPage: 1,  // Display 1 slide on mobile
            },
        },
    }).mount();
}
